const baseSplashScreenContent = {
  type: "image",
  inputType: "",
  label: "",
  data: {
    id: "",
    key: "",
    value: "",
    type: "splashscreen",
    file: {},
    isUpdated: false,
  },
  translation: {
    id: "",
    name: "",
    translationableId: "",
    translationableType: "Resource",
    adminId: "",
    languageId: "",
    flag: true,
    isUpdated: false,
  },
};

const createSplashScreenEntry = (title: string, key: string) => ({
  title,
  content: {
    ...baseSplashScreenContent,
    data: {
      ...baseSplashScreenContent.data,
      key,
      value: "", // value remains empty as in the original
    },
    translation: {
      ...baseSplashScreenContent.translation,
    },
  },
  isRequired: false,
  readonly: false,
  isButton: true,
});

const splashScreenEntries = [
  { title: "Splash Screen", key: "splashScreen" },
  { title: "No Winner Splash Screen", key: "noWinnerSplashScreen" },
  { title: "Currently Unavailable", key: "currentlyUnavailable" },
  { title: "No Connection", key: "noConnection" },
];

const splashScreens = splashScreenEntries.map(({ title, key }) => createSplashScreenEntry(title, key));

export { splashScreens };
